import React from "react";
import { Box } from "@mui/material";
import { GroupReliefOptimiserWorkspace } from "../components/Console-Panel/gro-tools";

const GroupReliefOptimiserPage = () => {
  return (
    <Box
      sx={{
        height: "100%",
        minHeight: "100%",
        bgcolor: "background.default",
      }}
    >
      <GroupReliefOptimiserWorkspace />
    </Box>
  );
};

export default GroupReliefOptimiserPage;
